<script>
  import Spinner from '../Spinner/Spinner.svelte';

  export let type = 'primary',
    size = '',
    link = null,
    fullwidth = false,
    disabled = false,
    id = null,
    loading = false,
    testid = null,
    collectid = null,
    responsive = false;
</script>

<style lang="scss">
  @import '../../styles/settings/core';
  @import '../../styles/settings/global';
  @import '../../styles/settings/colors';
  @import '../../styles/tools/media-query';

  .button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: spacing(1.5) spacing(3);
    height: spacing(6);
    min-width: spacing(32);
    max-width: 100%;
    white-space: nowrap;
    font: inherit;
    font-weight: 600;
    vertical-align: middle;
    border: 0;
    border-radius: 2.5rem;
    overflow: visible;
    cursor: pointer;
    transition: background-color $global-transition-duration;

    &,
    &:hover,
    &:active,
    &:focus {
      text-decoration: none;
    }

    &:focus {
      border: 2px solid $white;
      box-shadow: 0 0 0 2px $orange-50;
      outline: none;
      padding: spacing(1.5) spacing(3);
    }

    &:disabled,
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }

    @include mq($until: tabletportrait) {
      width: 100%;
    }

    &.primary {
      background-color: $orange-50;
      color: $white;

      &:hover {
        background-color: $orange-60;
      }

      &:active {
        background-color: $orange-70;
      }
    }

    &.secondary {
      background-color: $pink-30;
      color: $purple-40;

      &:hover {
        background-color: $pink-60;
      }

      &:active {
        background-color: $pink-70;
      }
    }

    &.fullwidth {
      width: 100%;
      min-width: auto;
    }

    &.responsive {
      max-width: fit-content;
    }
  }
</style>

{#if link}
  <a
    href={link}
    class={`button ${type} ${size}`}
    class:fullwidth
    class:responsive
    class:disabled
    {id}
    data-testid={testid}
    data-collectid={collectid}
    on:click
  >
    {#if loading}
      <Spinner />
    {:else}
      <slot />
    {/if}
  </a>
{:else}
  <button
    class={`button ${type} ${size}`}
    class:fullwidth
    class:responsive
    on:click
    on:message
    {disabled}
    {id}
    data-testid={testid}
    data-collectid={collectid}
  >
    {#if loading}
      <Spinner />
    {:else}
      <slot />
    {/if}
  </button>
{/if}
